import React, { useState } from 'react'

import { Skeleton, usePAWStore } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { useTranslation } from '~/app/i18n/client'
import { LeaderboardItems } from '../components/leaderboard-items'
import { PAWSectionType } from './paw-section-types'

export const Sales: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()
  const { t: translate } = useTranslation()
  const { date } = usePAWStore((state) => state)
  const [individualPage, setIndividualPage] = useState(0)
  const [rankingsPage, setRankingsPage] = useState(0)

  const { data: rankings, isLoading: rankingsLoading } =
    api.pawDashboards.getTeamRankings.useQuery({
      rankByCurrency: ['POINTS'],
      year: date?.year,
      page: rankingsPage,
      ...(content?.metadata?.params ?? {}),
    })

  const { data: individual, isLoading: individualLeaderboardLoading } =
    api.pawDashboards.getIndividualLeaderboard.useQuery({
      rankByCurrency: ['POINTS'],
      year: date?.year,
      page: individualPage,
      ...(content?.metadata?.params ?? {}),
    })

  const isLoading = individualLeaderboardLoading || rankingsLoading

  const getPrevOrNext =
    (type: 'individual' | 'rankings') => (action: 'prev' | 'next') => {
      if (type === 'individual') {
        action === 'next'
          ? setIndividualPage((prev) => prev + 1)
          : setIndividualPage((prev) => prev - 1)
        return
      }

      action === 'next'
        ? setRankingsPage((prev) => prev + 1)
        : setRankingsPage((prev) => prev - 1)
    }

  return (
    <section id={content?.sectionId} data-testid={content?.sectionId}>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h3 className="text-xl font-semibold">{content?.title ?? 'Sales'}</h3>
        </div>
        {isLoading ? (
          <Skeleton className="h-[250px] w-full" />
        ) : individual?.items?.length || rankings?.items?.length ? (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <LeaderboardItems
              items={individual?.items}
              rawLeaderboard={individual}
              getPrevOrNext={getPrevOrNext('individual')}
            />
            <LeaderboardItems
              items={rankings?.items}
              rawLeaderboard={rankings}
              getPrevOrNext={getPrevOrNext('rankings')}
              isTeamSpecific
            />
          </div>
        ) : (
          <div className="text-sm text-slate-800">
            {translate('pawDashboards.noDataFound')}
          </div>
        )}
      </div>
    </section>
  )
}
